<p-tabView #primeTabMenu 
           [orientation]="orientation"
           (onChange)="activeIndexChange.emit($event.index)">

    <ng-content></ng-content>

</p-tabView>